export const getDomain = () => {
    const API_URL = process.env.REACT_APP_API_URL || ''
    return API_URL || 'http://localhost:6017'
}

const handleInvalidToken = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('user');

    window.location.href = '/login';
}

function getAuthHeaders() {
    let token = localStorage.getItem('accessToken');
    if (!token) token = sessionStorage.getItem('accessToken');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
}

let http = {
    async get(url, params) {
        const urlWithParams = params ? url + '?' + Object.entries(params).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&') : url;
        return await fetch(getDomain() + urlWithParams, {
            headers: {
                ...getAuthHeaders()
            }
        })
        .then(r => r.json()).then(r => {
            console.log('[http.get] raw response:', JSON.stringify(r, null, 2).slice(0, 500));
            if (r.success === false && (r.message === 'Invalid token' || r.error === 'invalid token')) {
                handleInvalidToken();
                return;
            }
            
            if (params?.raw) {
                return r;
            }
            
            return (r.data || {}).items || (r.data) || r || {};
        })
    },
    async post(url, params) {
        return await fetch(getDomain() + url, {
            method: 'POST',         // Specify the request method
            headers: {
                'Content-Type': 'application/json',   // Set the content type header
                ...getAuthHeaders()
            },
            body: JSON.stringify(params)   // Convert the post data to a JSON string
        })
            .then(r => r.json())
            .then(r => {
            console.log('rrrrr', r)
            
            if (r.success === false && (r.message === 'Invalid token' || r.error === 'invalid token')) {
                handleInvalidToken();
                return;
            }
            
            return (r.data || {}).items || (r.data) || r || {};
        })
    },
    async verifyEmail(token) {
        return await fetch(getDomain() + '/api/users/auth/verify-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify({ token })
        })
            .then(r => r.json())
            .then(r => {
                console.log('verifyEmail response', r)

                if (r.success === false && (r.message === 'Invalid token' || r.error === 'invalid token')) {
                    handleInvalidToken();
                    return;
                }
                
                return (r.data || {}).items || (r.data) || r || {};
            })
    },
    async put(url, params) {
        return await fetch(getDomain() + url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(params)
        })
            .then(r => r.json())
            .then(r => {
                console.log('rrrrr', r)
                
                if (r.success === false && (r.message === 'Invalid token' || r.error === 'invalid token')) {
                    handleInvalidToken();
                    return;
                }
                
                return (r.data || {}).items || (r.data) || r || {};
            })
    },
    async upload(url, formData) {
        return await fetch(getDomain() + url, {
            method: 'POST',
            headers: {
                ...getAuthHeaders()
            },
            body: formData
        })
            .then(r => r.json())
            .then(r => {
                console.log('upload response', r)
                
                if (r.success === false && (r.message === 'Invalid token' || r.error === 'invalid token')) {
                    handleInvalidToken();
                    return;
                }
                
                return (r.data || {}).items || (r.data) || r || {};
            })
    }
}

export default http;
